class SearchDrawer extends HTMLElement {
  constructor() {
    super();

    this.overlay = this.querySelector('#SearchDrawer-Overlay');
    this.input = this.querySelector('input[type="search"]');

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));
  }

  open() {
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      if (this.input) this.input.focus();
    });

    this.addEventListener(
      'transitionend',
      () => {
        trapFocus(this.querySelector('.drawer__inner'), this.input);
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus();
    if (this.input) this.input.blur();
  }
}

customElements.define('search-drawer', SearchDrawer);
